import Vue from 'vue'
import App from './App.vue'
import router from './router'
//import './registerServiceWorker'

import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faHome,
    faChevronRight,
    faChevronLeft,
    faSpinner,
    faCheck,
    faTimes,
    faThumbsUp,
    faThumbsDown,
    faClock,
    faHistory,
    faTrophy
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'



library.add(faHome, faChevronRight, faChevronLeft, faSpinner, faCheck, faTimes, faThumbsUp, faThumbsDown, faClock, faHistory, faTrophy)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import VueNumeric from 'vue-numeric'

Vue.use(VueNumeric)

//Vue.config.productionTip = false
Vue.filter('formatNumber', function (value) {
    const rounded =  Math.round(value * 100) / 100
    return rounded.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});

let vm = new Vue({
    data: {
        loading: false,
    },
    watch: {},
    mounted() {
    },
    router,
    render: h => h(App)
}).$mount('#app')
